/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Paywall_Color_TitleInputs */

const en_onboarding_paywall_color_title = /** @type {(inputs: Onboarding_Paywall_Color_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3.6x longer`)
};

const ar_onboarding_paywall_color_title = /** @type {(inputs: Onboarding_Paywall_Color_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أطول بـ 3.6 مرات`)
};

const de_onboarding_paywall_color_title = /** @type {(inputs: Onboarding_Paywall_Color_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3.6x länger`)
};

const es_onboarding_paywall_color_title = /** @type {(inputs: Onboarding_Paywall_Color_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3.6 veces más`)
};

const fr_onboarding_paywall_color_title = /** @type {(inputs: Onboarding_Paywall_Color_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3,6x plus longtemps`)
};

const it_onboarding_paywall_color_title = /** @type {(inputs: Onboarding_Paywall_Color_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3.6x più a lungo`)
};

const ja_onboarding_paywall_color_title = /** @type {(inputs: Onboarding_Paywall_Color_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3.6倍長く`)
};

const ko_onboarding_paywall_color_title = /** @type {(inputs: Onboarding_Paywall_Color_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3.6배 더 길어요`)
};

const pt_br_onboarding_paywall_color_title = /** @type {(inputs: Onboarding_Paywall_Color_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3,6x mais tempo`)
};

const ru_onboarding_paywall_color_title = /** @type {(inputs: Onboarding_Paywall_Color_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3,6 раза дольше`)
};

const th_onboarding_paywall_color_title = /** @type {(inputs: Onboarding_Paywall_Color_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3.6 เท่า`)
};

const tr_onboarding_paywall_color_title = /** @type {(inputs: Onboarding_Paywall_Color_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3,6 kat daha uzun`)
};

const zh_cn_onboarding_paywall_color_title = /** @type {(inputs: Onboarding_Paywall_Color_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3.6 倍`)
};

const zh_tw_onboarding_paywall_color_title = /** @type {(inputs: Onboarding_Paywall_Color_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3.6 倍`)
};

/**
* | output |
* | --- |
* | "3.6x longer" |
*
* @param {Onboarding_Paywall_Color_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const onboarding_paywall_color_title = /** @type {((inputs?: Onboarding_Paywall_Color_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Paywall_Color_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_paywall_color_title(inputs)
	if (locale === "ar") return ar_onboarding_paywall_color_title(inputs)
	if (locale === "de") return de_onboarding_paywall_color_title(inputs)
	if (locale === "es") return es_onboarding_paywall_color_title(inputs)
	if (locale === "fr") return fr_onboarding_paywall_color_title(inputs)
	if (locale === "it") return it_onboarding_paywall_color_title(inputs)
	if (locale === "ja") return ja_onboarding_paywall_color_title(inputs)
	if (locale === "ko") return ko_onboarding_paywall_color_title(inputs)
	if (locale === "pt_br") return pt_br_onboarding_paywall_color_title(inputs)
	if (locale === "ru") return ru_onboarding_paywall_color_title(inputs)
	if (locale === "th") return th_onboarding_paywall_color_title(inputs)
	if (locale === "tr") return tr_onboarding_paywall_color_title(inputs)
	if (locale === "zh_cn") return zh_cn_onboarding_paywall_color_title(inputs)
	return zh_tw_onboarding_paywall_color_title(inputs)
});